import React, { useState,useEffect, useRef } from "react";
import { useNavigate } from 'react-router-dom';
import { db, auth } from '../../firebase';
import { doc, getDoc, query, where, getDocs, collection,addDoc,serverTimestamp } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { onAuthStateChanged } from 'firebase/auth';
import { getCountFromServer } from "firebase/firestore";  

import {
  Home,
  BookOpen,
  ClipboardList,
  Upload,
  MoreHorizontal,
  Pencil,
  Trophy,
  Download,
  Clock,
  School,
 Zap,
 Crown,
 ArrowUpCircle
} from "lucide-react";

export default function Sidebar({
  open,
  setOpen,
  profileExists,
  userName,
  persona,
  handleNavigation,
  handleLogout,
}) {
  const [hoveredDrawerItem, setHoveredDrawerItem] = useState(null);

    const [sharedCount, setSharedCount] = useState(0);

    const[email,setEmail] = useState(null);

    const [rewardCount, setRewardCount] = useState(0);

    const [rewardsDisabled, setRewardsDisabled] = useState(false);

useEffect(() => {
  const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
    if (!currentUser) {
      setRewardsDisabled(false);
      return;
    }

    try {
      const profileSnap = await getDoc(doc(db, "profiles", currentUser.uid));
      setRewardsDisabled(profileSnap.exists() && profileSnap.data().paidUser === true);
    } catch (error) {
      console.error("Error checking rewards access:", error);
    }
  });

  return () => unsubscribe();
}, []);

    useEffect(() => {
      const fetchRewardCount = async () => {
        const currentUser = auth.currentUser;
        if (!currentUser) return;
    
        try {
          // 1️⃣ Total Captures
          const captureQuery = query(
            collection(db, "Reward_Capture"),
            where("user_email", "==", currentUser.email)
          );
    
          const captureSnapshot = await getCountFromServer(captureQuery);
          const totalCaptures = captureSnapshot.data().count;
    
          const unlockedRewards = Math.floor(totalCaptures / 10);
    
          // 2️⃣ Total Claimed
          const claimedQuery = query(
            collection(db, "Reward_Claimed"),
            where("email", "==", currentUser.email)
          );
    
          const claimedSnapshot = await getCountFromServer(claimedQuery);
          const totalClaimed = claimedSnapshot.data().count;
    
          // 3️⃣ Available Rewards
          const availableRewards = unlockedRewards - totalClaimed;
    
          setRewardCount(Math.max(availableRewards, 0)); // 🔥 never go negative
    
        } catch (error) {
          console.error("Error fetching reward count:", error);
        }
      };
    
      fetchRewardCount();
    }, []);
    
    useEffect(() => {
      const fetchSharedWorksheetsCount = async () => {
        const currentUser = auth.currentUser;
        if (!currentUser) return;

        setEmail(currentUser.email);
    
        try {
          // 1️⃣ Fetch shared worksheets
          const sharedQuery = query(
            collection(db, "Shared_Worksheets"),
            where("friendEmail", "==", currentUser.email)
          );
    
          const sharedSnapshot = await getDocs(sharedQuery);
    
          // Deduplicate shared by fileUrl
          const sharedFileUrls = new Set();
    
          sharedSnapshot.docs.forEach((docSnap) => {
            const data = docSnap.data();
            if (data.fileUrl) {
              sharedFileUrls.add(data.fileUrl);
            }
          });
    
          // 2️⃣ Fetch downloaded worksheets
          const downloadQuery = query(
            collection(db, "Downloads_And_Generations"),
            where("email", "==", currentUser.email)
          );
    
          const downloadSnapshot = await getDocs(downloadQuery);
    
          // Deduplicate downloads by fileUrl
          const downloadedFileUrls = new Set();
    
          downloadSnapshot.docs.forEach((docSnap) => {
            const data = docSnap.data();
            if (data.fileUrl) {
              downloadedFileUrls.add(data.fileUrl);
            }
          });
    
          // 3️⃣ Subtract downloaded from shared
          let remainingCount = 0;
    
          sharedFileUrls.forEach((fileUrl) => {
            if (!downloadedFileUrls.has(fileUrl)) {
              remainingCount++;
            }
          });
    
          setSharedCount(remainingCount);
    
        } catch (error) {
          console.error("Error fetching shared worksheets:", error);
        }
      };
    
      fetchSharedWorksheetsCount();
    }, []);

  const drawerItems = [
    !profileExists && {
      label: "Create Profile",
      key: "createProfile",
      icon: <Pencil className="w-4 h-4" />,
      onClick: () => handleNavigation("/create-profile", { state: { persona } }),
    },
    profileExists && {
      label: "Edit Profile",
      key: "editProfile",
      icon: <Pencil className="w-4 h-4" />,
      onClick: () => handleNavigation("/edit-profile", { persona }),
    },
    profileExists && {
      label: "My Uploads",
      className: "hidden lg:flex",
      key: "myWorksheets",
      icon: <BookOpen className="w-4 h-4" />,
      onClick: () => handleNavigation("/UserUploadsPage"),
    },
    profileExists && {
      label: "My Downloads",
      className: "hidden lg:flex",
      key: "mydownloads",
      icon: <ClipboardList className="w-4 h-4" />,
      onClick: () => handleNavigation("/UserDownloadPage"),
    },

    profileExists && {
      label: "My Quiz Results",
      className: "hidden lg:flex",
      key: "AI Test Results Dashboard",
      icon: <Trophy className="w-4 h-4" />,
      onClick: () => handleNavigation("/TestResultsDashboard"),
    },

profileExists && 1==2 && {
  label: "Received Worksheets",
  key: "myreceivebleworksheets",
  className: "hidden lg:flex",
  icon: (
    <div className="relative">
      <Download className="w-4 h-4" />

      <div
        className="
          absolute -top-1 -right-3
          bg-red-500 text-white
          text-[9px] font-bold
          w-6 h-6
          flex items-center justify-center
          shadow-md
        "
        style={{
          clipPath:
            "polygon(50% 0%, 61% 35%, 98% 35%, 68% 57%, 79% 91%, 50% 70%, 21% 91%, 32% 57%, 2% 35%, 39% 35%)"
        }}
      >
        {sharedCount}
      </div>
    </div>
  ),
  onClick: () =>
    handleNavigation("/download-forms", {
      type: "All Types",
      subject: "All Subjects",
      shared: true,
    }),
},

profileExists && {
  label: rewardsDisabled ? "Premium User" : "Upgrade to Premium",
  key: "premium",
  icon: (
    <div className="relative shrink-0">
      <Crown className="w-4 h-4 text-yellow-300" />
      <span className="absolute -top-1 -right-1 flex h-2 w-2">
        <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-yellow-300 opacity-75"></span>
        <span className="relative inline-flex rounded-full h-2 w-2 bg-yellow-400"></span>
      </span>
    </div>
  ),
  className:
    "bg-gradient-to-r from-indigo-600 to-violet-600 text-white text-sm font-semibold shadow-md border border-indigo-400 hover:scale-[1.01] transition-all duration-300 overflow-hidden whitespace-nowrap",
  onClick: () => handleNavigation("/PremiumUpgradePage"),
},

    profileExists && {
      label: "My Recent Activity",
      key: "recentactivity",
      icon: <Clock className="w-4 h-4" />,
      onClick: () => handleNavigation("/Recent_Activity"),
    },

    profileExists && {
      label: "Feedback",
      key: "userFeedback",
      icon: <MoreHorizontal className="w-4 h-4" />,
      onClick: () => handleNavigation("/feedback"),
    },
 
    {
      label: "Logout",
      key: "logout",
      icon: <Home className="w-4 h-4" />,
      onClick: handleLogout,
      isLogout: true,
    },
  ].filter(Boolean);

return (
    <>
      {/* Mobile Overlay */}
      {open && (
        <div
          className="fixed inset-0 bg-black/40 z-40 lg:hidden"
          onClick={() => setOpen(false)}
        />
      )}

      <aside
        className={`
          fixed top-0 left-0 h-[100dvh] w-64 bg-white border-r border-gray-200
          transform transition-transform duration-300 z-50 
          flex flex-col overflow-y-auto /* 🔥 The magic scrolling classes */
          ${open ? "translate-x-0" : "-translate-x-full"}
          lg:translate-x-0
        `}
      >
        {/* 1. Header (Top) */}
<div className="p-5 border-b shrink-0">
  <div className="flex items-center justify-between gap-3">
    <div className="min-w-0 flex-1">
      {email && (
        <div className="text-xs text-gray-500 font-bold truncate mt-1">
          {email}
        </div>
      )}
    </div>


   {/*  <button
      type="button"
      onClick={() => {
        handleNavigation("/EascodeChat");
        setOpen(false);
      }}
      className="hidden lg:flex flex-col items-center justify-center shrink-0"
    >
      <span className="w-12 h-12 rounded-full bg-white border border-blue-100 shadow-md flex items-center justify-center hover:scale-105 transition">
        <img
          src="/Eascode_No_Background.png"
          alt="Easy"
          className="w-full h-full object-contain rounded-full"
        />
      </span>

      <p className="text-sm font-black text-blue-600 mt-1 leading-none notranslate">
        Easy
      </p>
    </button> */}



  </div>
</div>

        {/* 2. Navigation Links (Middle) */}
        <nav className="p-4 space-y-2 shrink-0">
          {drawerItems.map((item) => (
            <SidebarItem
              key={item.key}
              icon={item.icon}
              label={item.label}
              isLogout={item.isLogout}
              className={item.className}
              hovered={hoveredDrawerItem === item.key}
              onHover={() => setHoveredDrawerItem(item.key)}
              onLeave={() => setHoveredDrawerItem(null)}
              onClick={() => {
                item.onClick();
                setOpen(false);
              }}
            />
          ))}
        </nav>

        {/* 3. Footer Actions (Bottom - Pushed down by mt-auto) */}
        <div className="mt-auto p-4 border-t border-gray-100 flex flex-col gap-5 shrink-0 bg-gray-50/50">
          
          {/* 🎁 REWARD JOURNEY */}
          <button
            //disabled={rewardsDisabled}
            //aria-disabled={rewardsDisabled}
            onClick={() => {
              //if (rewardsDisabled) return;
              handleNavigation('/RewardJourney');
              setOpen(false); // Close sidebar on click
            }}
            className="w-full flex items-center gap-3
                       px-4 py-3
                       rounded-xl
                       bg-gradient-to-r from-amber-50 to-orange-50
                       border border-amber-100
                       text-gray-800
                       transition-all duration-200
                       active:scale-95 shadow-sm"
          >
            <div className="relative shrink-0">
              <img
                src="/Open_Gift_Box.jpg"
                alt="Reward"
                className="w-8 h-8 object-contain"
              />
              {/* Mobile Badge */}
              {rewardCount > 0 && (
                <span className="absolute -top-1 -right-1 flex h-3 w-3 lg:hidden">
                  <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-400 opacity-75"></span>
                  <span className="relative inline-flex rounded-full h-3 w-3 bg-red-500"></span>
                </span>
              )}
            </div>

            <div className="flex flex-col items-start overflow-hidden">
              <span className="text-sm font-bold text-amber-900 w-full text-left">{"Reward Journey"}</span>
              {rewardCount > 0 && (
                <span className="text-[10px] text-orange-700 font-medium lg:hidden">
                  {rewardCount} rewards waiting
                </span>
              )}
            </div>

            {/* Desktop Badge */}
            {rewardCount > 0 && (
              <div className="hidden lg:flex ml-auto bg-red-500 text-white text-[10px] font-bold px-2 py-0.5 rounded-full animate-pulse">
                {rewardCount}
              </div>
            )}
          </button>

          {/* 🤝 SHARE APP */}
          <div className="flex justify-center w-full pb-4">
            <img
              src="../Share.png"
              alt="Share Eascode App"
              onClick={() => {
                handleNavigation("/ReferFriend");
                setOpen(false);
              }}
              className="w-36 h-12 object-contain cursor-pointer
                         transition-all duration-200
                         hover:scale-105 hover:drop-shadow-lg
                         active:scale-95"
            />
          </div>
        </div>
      </aside>
    </>
  );
}

function SidebarItem({ label, icon, hovered, onHover, onLeave, onClick, isLogout, className }) {
  return (
    <button
      className={`
        w-full flex items-center gap-3 text-left px-4 py-3 rounded-lg
        transition-colors duration-200
        ${isLogout ? "text-red-600 hover:bg-red-50" : "text-gray-600 hover:bg-gray-100 hover:text-gray-800"}
        ${hovered ? "text-blue-600 bg-blue-50/50" : ""}
        ${className || ""}
      `}
      onMouseEnter={onHover}
      onMouseLeave={onLeave}
      onClick={onClick}
    >
      <span className="shrink-0">{icon}</span>
      <span className="truncate">{label}</span>
    </button>
  );

}

